import { render, staticRenderFns } from "./BatchesProduct.template.vue?vue&type=template&id=993c2842&scoped=true&"
var script = {}
import style0 from "./BatchesProduct.template.vue?vue&type=style&index=0&id=993c2842&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993c2842",
  null
  
)

export default component.exports